export const pendingActionsTranslations = {
    en: {
        // Page Title
        pendingActions: "Pending Actions",

        // Tab Labels
        mo: "MO",
        tho: "THO",
        dho: "DHO",
        central: "Central",

        // Table Headers
        action: "Action",
        campName: "Camp Name",
        address: "Address",
        campStatus: "Camp Status",
        startDate: "Start Date",
        endDate: "End Date",
        acceptBefore: "Accept Before",
        pendingActionBy: "Pending Action By",
        pendingSince: "Pending Since",

        // Buttons
        takeAction: "Take Action",

        // Drawer Titles
        takeActionTitle: "Take Action",

        // Status Labels
        status: "Status",

        // Common
        notAvailable: "N/A",
        loading: "Loading...",
        unknown: "Unknown",

        // Module Name
        pendingActionsModule: "Pending Actions",

        // Time Format
        days: "d",
        hours: "h",
    },
    mr: {
        // Page Title
        pendingActions: "प्रलंबित क्रिया",

        // Tab Labels
        mo: "MO",
        tho: "THO",
        dho: "DHO",
        central: "केंद्रीय",

        // Table Headers
        action: "क्रिया",
        campName: "शिबिराचे नाव",
        address: "पत्ता",
        campStatus: "शिबिर स्थिती",
        startDate: "प्रारंभ तारीख",
        endDate: "समाप्ती तारीख",
        acceptBefore: "आधी स्वीकारा",
        pendingActionBy: "द्वारे प्रलंबित क्रिया",
        pendingSince: "पासून प्रलंबित",

        // Buttons
        takeAction: "कारवाई करा",

        // Drawer Titles
        takeActionTitle: "कारवाई करा",

        // Status Labels
        status: "स्थिती",

        // Common
        notAvailable: "उपलब्ध नाही",
        loading: "लोड करत आहे...",
        unknown: "अज्ञात",

        // Module Name
        pendingActionsModule: "प्रलंबित क्रिया",

        // Time Format
        days: "दि",
        hours: "ता",
    }
};
